import { Paper, Tooltip, Typography } from '@material-ui/core'
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined'

import { useStyles } from './styles'

export interface CardProps {
  title: string
  subtitle: string
  tooltipMessage: string
}

export default function Card({ title, subtitle, tooltipMessage }: CardProps) {
  const classes = useStyles()

  return (
    <Paper elevation={2} className={classes.card}>
      <Tooltip
        title={tooltipMessage}
        placement='right'
        classes={{
          tooltip: classes.tooltip,
        }}
      >
        <InfoOutlinedIcon />
      </Tooltip>
      <Typography variant='h2'>{title}</Typography>
      <Typography variant='subtitle2'>{subtitle}</Typography>
    </Paper>
  )
}
